import apiConfig from '../../config/apiConfig'
import { createBrandApiRequest } from '../utils/brandApiUtils'

export const createUserService = ({ axiosInstance } = {}) => {
  const { apiKey = '', brandAPIs = {} } = apiConfig
  const request = createBrandApiRequest({ apiKey, axiosInstance })

  return {
    registerUser: () =>
      request({
        endpoint: brandAPIs.USER,
        method: 'post',
      }),
  }
}

export const userService = createUserService()
